import { uploadServer } from '../axios'
const file = {
	// 文件上传
	uploadFile: (params) => uploadServer('/web/file/uploadFile', params)
}
export default file